import type { ReactNode } from "react";
import styles from "./AnimatedCardStack.module.scss";

type MemoryCardFlipSpringShellProps = {
  flipped: boolean;
  children: ReactNode;
};

export function MemoryCardFlipSpringShell({
  flipped,
  children,
}: MemoryCardFlipSpringShellProps) {
  return (
    <div
      className={`${styles.flipper}${flipped ? ` ${styles.flipRootFlipped}` : ""}`}
    >
      {children}
    </div>
  );
}
